// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tripStatusEntity from './entities/trip-status.json';
import tripStatusMenu from '../pages/trip-status/menu.json';
import tripStatusFullForm from '../pages/trip-status/forms/full.json';
import tripStatusContextForm from '../pages/trip-status/forms/context.json';
import tripStatusMiniForm from '../pages/trip-status/forms/mini.json';
import tripStatusLookupForm from '../pages/trip-status/forms/lookup.json';
import tripStatusTableView from '../pages/trip-status/views/table.json';
import tripStatusDashboardView from '../pages/trip-status/views/dashboard.json';

/** Тип запису «Статус поїздки» зі сторінками пакета: меню, форми та подання з pages/trip-status/. */
export const tripStatusDefinition: IRecordTypeDefinition = {
  ...tripStatusEntity,
  views: assembleViewSet({
      table: tripStatusTableView,
      dashboard: tripStatusDashboardView,
  }),
  form: tripStatusFullForm,
  forms: { full: tripStatusFullForm, context: tripStatusContextForm, mini: tripStatusMiniForm, lookup: tripStatusLookupForm },
  menu: tripStatusMenu,
} as IRecordTypeDefinition;
